var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16406,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6641 12C13.1118 12 12.6641 12.4477 12.6641 13V27C12.6641 27.5523 13.1118 28 13.6641 28H27.6641C28.2163 28 28.6641 27.5523 28.6641 27V13C28.6641 12.4477 28.2163 12 27.6641 12H13.6641ZM10.6641 13C10.6641 11.3431 12.0072 10 13.6641 10H27.6641C29.3209 10 30.6641 11.3431 30.6641 13V27C30.6641 28.6569 29.3209 30 27.6641 30H13.6641C12.0072 30 10.6641 28.6569 10.6641 27V13Z",
    fill: "#EB8146"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordStopIcon);
export default __webpack_public_path__ + "static/media/record-stop-icon.89db8b1bbd4dd57200dcc51f0845b47f.svg";
export { ForwardRef as ReactComponent };